const unitTemplates = {}

import units from "@frog/source/data/units.js"
Object.values(units).forEach((unit) => {
    unitTemplates["jobs/" + unit.jobKey] = {
        "templateKey": "jobs/" + unit.jobKey,
        "jobKey": unit.jobKey,
        "affiliation": "bad",
    }
})

export const UNIT_JOB_LISTS = {
    "infantry": ["sword", "spear", "hammer"],
    "ranged": ["dagger", "bow", "gun"],
    "mounted": ["swordcavalier", "spearcavalier", "hammercavalier"],
    "armored": ["swordknight", "spearknight", "hammerknight"],
    "swordhavers": ["sword", "dagger", "swordknight", "swordcavalier"],
    "spearhavers": ["spear", "bow", "spearknight", "spearcavalier"],
    "hammerhavers": ["hammer", "gun", "hammerknight", "hammercavalier"],
    "melee": [
        "sword", "spear", "hammer",
        "swordknight", "spearknight", "hammerknight",
        "swordcavalier", "spearcavalier", "hammercavalier"
    ],
    "basic": [
        "sword", "spear", "hammer",
        "dagger", "bow"
    ],
    "advanced": [
        "sword", "spear", "hammer", "dagger", "bow",
        "sword", "spear", "hammer", "dagger", "bow",
        "swordknight", "spearknight", "hammerknight",
        "swordcavalier", "spearcavalier", "hammercavalier",
    ]
}
for (const [key, value] of Object.entries(UNIT_JOB_LISTS)) {
    unitTemplates["randoms/"+key] = {
        "randomJobKey": value.join(","),
        "templateKey": "randoms/"+key,
        "affiliation": "bad",
    }
}

unitTemplates["spawnspot"] = {
    "type": "zone",
    "affiliation": "none",
    "templateKey": "spawnspot",
}

import game from "@frog/source/data/games/pirates/index.js"
Object.keys(game.player.party.units).forEach((unitKey) => {
    unitTemplates["player/" + unitKey] = {
        "templateKey": "player/" + unitKey,
        "key": unitKey
    }
})

const dungeonParty = ["swordlord", "spearknight", "axeknight", "highpriest", "daggercloak", "gunner"]
dungeonParty.forEach((unitKey) => {
    unitTemplates["player/" + unitKey] = {
        "templateKey": "player/" + unitKey,
        "key": unitKey
    }
})

export default unitTemplates
